import { render, staticRenderFns } from "./LeaveIcon.vue?vue&type=template&id=1ec7cb62&scoped=true"
import script from "./LeaveIcon.vue?vue&type=script&lang=js"
export * from "./LeaveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec7cb62",
  null
  
)

export default component.exports